import { GP_ID_COMBUSTIBLES_AFINES } from "./constants"

export const isCombustibleAfines = (grupoProductoId :number) =>  {
    return grupoProductoId === GP_ID_COMBUSTIBLES_AFINES || grupoProductoId === 14 || grupoProductoId === 16
}

export const isCombustible = (grupoProductoId :number) =>  {
    return grupoProductoId === 10 || grupoProductoId === 14
}
export const isShellFlota = (grupoProductoId :number) =>  {
    return grupoProductoId === 16
}

export const isNullOrUndef : (str:any) => boolean = (str) => {
    return str === null || str === undefined;
}

export const isEmptyArrayOrNull : (arr: any[] | null | undefined) => boolean = (arr) => {
    return arr === null || arr === undefined || arr.length === 0;
}